import * as React from "react";
import { DownloadButton } from "./DownloadButton.js";

export const DownloadPlugin = ({ augment }) => {
  augment(({ toolbar: { buttons, ...restToolbar }, ...restProps }) => ({
    toolbar: {
      buttons: [
        React.createElement(DownloadButton, { key: "download" }),
        ...buttons,
      ],
      ...restToolbar,
    },
    ...restProps,
  }));
};
